module.exports = __webpack_public_path__ + "img/AL.2bc7f480.png";